<template>
  <v-navigation-drawer
    v-if="systemSettings !== undefined"
    id="app-drawer"
    v-model="inputValue"
    :style="{backgroundColor: 'rgba(190, 202, 234, 1)' }"
    app
    dark
    color="dover-blue-color"
    right
    floating
    persistent
    mobile-break-point="991"
    width="240">
    <v-img
      :src="image"
      height="100%">
      <v-layout
        class="fill-height"
        tag="v-list"
        column>
        <v-list-tile avatar>
          <v-list-tile-avatar
            color="white">
            <v-img
              :src="logo"
              height="34"
              contain/>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="title">
              LX {{ webVersion }}
            </v-list-tile-title>
            <v-list-tile-sub-title
              v-if="Maglink.isPlus">
              PB {{ featureSettings.firmware }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider/>
        <!--
        <v-list-tile
          v-if="responsive">
          <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="dover-blue"/>
        </v-list-tile>
        -->
        <!-- MAIN MENU -->
        <v-list-tile
          v-for="(item, i) in links"
          :key="i"
          :to="item.to"
          active-class="dover-blue"
          avatar
          class="v-list-item">
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="`${ $t(item.text) }`"/>
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

import Vue from 'vue'
import { i18n } from '@/i18n'

export default {
  data: () => ({
    webVersion: '',
    systemSettings: { version: '' },
    featureSettings: { firmware: '' },
    logo: './img/tank/tank-yellow-070.svg',
    links: [],
    responsive: false
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    }
  },
  watch: {
    responsive (newValue, oldValue) {
      Vue.prototype.Maglink.isResponsive = newValue
    }
  },
  mounted () {
    // get current version
    this.Maglink.GetVersion()
      .then(response => {
        this.webVersion = response.data.SoftwareVersion

        this.Maglink.GetSettings('SystemSettings')
          .then(response => {
            this.systemSettings = { ...response.data }
            this.systemSettings.version = this.webVersion

            // clear cache based upon new web version
            // --------------------------------------------------------------
            let prevWebVersion = localStorage.getItem('webVersion')

            // if (prevWebVersion !== this.systemSettings.version) {
            if (prevWebVersion !== this.webVersion) {
              // localStorage.setItem('webVersion', this.systemSettings.version)
              localStorage.setItem('webVersion', this.webVersion)
              this.snack('error', 'Session timeout')
              window.location.reload(true)
            }
            // --------------------------------------------------------------
          })
          .catch(() => {
            this.snack('error', 'Session timeout')
          })
      })
      .catch(() => {
        this.snack('error', 'Session timeout')
      })

    this.Maglink.GetSettings('Features')
      .then(response => {
        let data = { ...response.data }

        Vue.prototype.Maglink.isPlus = data.maglinkType === 2
        this.buildLinks()

        if (Vue.prototype.Maglink.isPlus) {
          this.Maglink.GetPiggyback()
            .then(response => {
              let device = { ...response.data }
              if (device.device !== 0) {
                this.featureSettings.firmware = (device.softwareVersion * 0.01).toFixed(2)
              }
            })
            .catch(() => {
              this.snack('error', 'Session timeout')
            })
        }
      })
      .catch(() => {
        this.snack('error', 'Session timeout')
      })

    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    },
    buildLinks () {
      this.links = [
        {
          to: '/system',
          icon: 'mdi-cards-variant',
          text: 'System settings',
          active: !Vue.prototype.Maglink.LoggedUser.isGuest
        },
        {
          to: '/notifications',
          icon: 'mdi-account-details',
          text: 'Notifications',
          active: !Vue.prototype.Maglink.LoggedUser.isGuest
        },
        {
          to: '/tanks',
          icon: 'mdi-database',
          text: 'Tanks setup',
          active: !Vue.prototype.Maglink.LoggedUser.isGuest
        },
        {
          to: '/sensors',
          icon: 'mdi-database',
          text: 'Sensors Setup',
          active: !Vue.prototype.Maglink.LoggedUser.isGuest
        },
        {
          to: '/lineleakconfig',
          icon: 'mdi-database',
          text: 'Line Leak Setup',
          active: !Vue.prototype.Maglink.LoggedUser.isGuest && Vue.prototype.Maglink.isPlus
        },
        {
          to: '/tankstatus',
          icon: 'mdi-waves',
          text: 'Tank status',
          active: true
        },
        {
          to: '/sensorstatus',
          icon: 'mdi-cast',
          text: 'Sensor Status',
          active: true
        },
        {
          to: '/lineleakstatus',
          icon: 'mdi-pipe',
          text: 'Line Leak Status',
          active: Vue.prototype.Maglink.isPlus
        },
        {
          to: '/tankgroupstatus',
          icon: 'mdi-group',
          text: 'Tank group status',
          active: true
        },
        {
          to: '/reports',
          icon: 'mdi-chart-areaspline',
          text: 'Reports',
          active: true
        },
        {
          to: '/maintenance',
          icon: 'mdi-wrench',
          text: 'Maintenance',
          active: true
        },
        {
          to: '/passwordchange',
          icon: 'mdi-key-change',
          text: 'Change password',
          active: !Vue.prototype.Maglink.LoggedUser.isGuest
        },
        {
          to: '/translate',
          icon: 'mdi-translate',
          text: 'Translate',
          active: !Vue.prototype.Maglink.LoggedUser.isGuest
        },
        {
          to: '/landingpage',
          icon: 'mdi-account-off',
          text: 'Logout',
          active: true
        }
      ]

      let newLinks = []
      for (let index = 0; index < this.links.length; index++) {
        let item = this.links[index]
        if (item.active) newLinks.push(item)
      }
      this.links = newLinks
    },
    snack (color, message) {
      message = 'Drawer: ' + i18n.t(message)
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 9px;
      height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
